import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  CreatePppLinkRequestBody,
  CreatePppLinkResponse,
  DeletePppLinkPath,
  DeletePppLinkResponse,
  GetPppLinksQuery,
  GetPppLinksResponse,
  UpdatePppLinkPath,
  UpdatePppLinkResponse,
} from "../../interfaces/pppLink.interface";

const BASE = "/ppp-links";

export async function listPppLinks(params: GetPppLinksQuery) {
  const axios = await getTokenizedAxios();
  return axios
    .get<GetPppLinksResponse>(CONFIG.ADMIN_SERVER.BASE_URL + BASE, { params })
    .then((res) => res.data);
}

export async function createPppLink(body: CreatePppLinkRequestBody) {
  const axios = await getTokenizedAxios();
  return axios
    .post<CreatePppLinkResponse>(CONFIG.ADMIN_SERVER.BASE_URL + BASE, body)
    .then((res) => res.data);
}

export async function updatePppLink(path: UpdatePppLinkPath, body: any) {
  const axios = await getTokenizedAxios();
  const url = `${CONFIG.ADMIN_SERVER.BASE_URL + BASE}/${path.pppLinkId}`;
  return axios.put<UpdatePppLinkResponse>(url, body).then((res) => res.data);
}

export async function deletePppLink(path: DeletePppLinkPath) {
  const axios = await getTokenizedAxios();
  const url = `${CONFIG.ADMIN_SERVER.BASE_URL + BASE}/${path.code}`;
  return axios.delete<DeletePppLinkResponse>(url).then((res) => res.data);
}


